import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  createNgModule,
  inject,
  Injector,
  input,
  OnInit,
  PLATFORM_ID,
  viewChild,
  ViewContainerRef,
} from '@angular/core';

import { Observable } from 'rxjs';

import { CmsTemplate } from '@fcom/core-api';

@Component({
  selector: 'fin-render-lazy-wizard',
  templateUrl: './render-lazy-wizard.component.html',
  styleUrls: ['./render-lazy-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RenderLazyWizardComponent implements OnInit {
  private injector = inject(Injector);
  private platformId = inject(PLATFORM_ID);

  readonly lazyLoadComponent = viewChild.required('lazyLoadComponent', { read: ViewContainerRef });
  readonly template$ = input<Observable<CmsTemplate>>();

  ngOnInit(): void {
    // The lazy chunk is loaded via an untracked dynamic import(). On the server this
    // resolves after Angular has destroyed the app injector, so createNgModule() would
    // throw NG0205. This wizard is browser-only, so skip lazy loading during SSR.
    if (isPlatformBrowser(this.platformId)) {
      this.loadWizard();
    }
  }

  async loadWizard(): Promise<void> {
    const { MultiStepConditionalFormModule, MultiStepConditionalFormComponent } =
      await import('@fcom/service-forms-lazy/components/multi-step-conditional-forms');
    const moduleRef = createNgModule(MultiStepConditionalFormModule, this.injector);

    const componentRef = this.lazyLoadComponent().createComponent(MultiStepConditionalFormComponent, {
      ngModuleRef: moduleRef,
    });
    componentRef.setInput('template$', this.template$());
  }
}
